import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ConfirmDialogService } from '@serviceplan/ui-kit';
import { DateUtilityLib, SpDateFormatPipe } from '@thehubz/client/core';
import { UpdateAssetDto } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'thehubz-asset-deletion-dialog',
  templateUrl: './asset-deletion-dialog.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatIconModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatDialogModule],
})
export class AssetDeletionDialogComponent implements OnInit, OnDestroy {
  plannedDeletionDate = new FormControl();
  currentDate!: Date;
  bulkDeletion = false;
  plannedDeletionFlag = false;
  private assetDeletedSub: Subscription | undefined;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AnyType,
    private dialogRef: MatDialogRef<
      AssetDeletionDialogComponent,
      { confirm: boolean; actionType: string; plannedDeletionObj?: UpdateAssetDto; deletionDate?: string }
    >,
    private spDatePipe: SpDateFormatPipe,
    private confirmDialog: ConfirmDialogService,
  ) {}

  ngOnInit(): void {
    this.currentDate = new Date();
    if (this.data.planDeletion) this.plannedDeletionDate.setValue(this.data.planDeletion);
    else this.plannedDeletionDate.setValue(DateUtilityLib.addDaysToDate(this.currentDate.toString(), 7));
    if (this.data && this.data['planDeletionFlag']) {
      this.plannedDeletionFlag = true;
    } else if (this.data && this.data['bulkEdit']) {
      this.bulkDeletion = true;
    }
  }

  /**
   * Set asset planned deletion mark
   */
  planDeletion() {
    const formValue = this.plannedDeletionDate.getRawValue();
    const plannedDeletionObj: UpdateAssetDto = { plannedDeletion: formValue };
    const deletionDate = this.spDatePipe.transform(formValue?.toString());
    let message = this.bulkDeletion
      ? $localize`:plan deletion bulk:Are you sure you want to plan the deletion of the assets on`
      : $localize`:plan deletion:Are you sure you want to plan the deletion of the asset on`;
    message += ` ${deletionDate}?`;
    this.confirmDialog
      .open({
        title: $localize`Plan deletion`,
        message,
      })
      .subscribe((confirm) => {
        if (confirm) {
          this.dialogRef.close({ confirm, actionType: 'planDeletion', plannedDeletionObj, deletionDate });
        }
      });
  }

  /**
   * Delete asset
   */
  deleteAsset() {
    const message = this.bulkDeletion ? $localize`Are you sure you want to delete selected assets?` : $localize`Are you sure you want to delete this asset?`;
    this.confirmDialog
      .open({
        title: $localize`Delete ${this.bulkDeletion ? 'assets' : 'asset'}`,
        message,
      })
      .subscribe((confirm) => {
        if (confirm) {
          this.dialogRef.close({ confirm, actionType: 'deleteAsset' });
        }
      });
  }

  ngOnDestroy(): void {
    this.assetDeletedSub && this.assetDeletedSub.unsubscribe();
  }
}
